<template>
    <div class="country">
        <h1>Implementation of Past {{ title }} Agreements</h1>
        <p>Please select an agreement to explore reports on how different provisions and topics were implemented.</p>
    </div>
</template>

<script>
export default ({
    props: ["title"]
})
</script>